import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'hooks';
import { toggleBackButtonState } from 'store/common';

import { IHeader } from './Header';
import { BackButton, ChildContent, Container, EmptyBox, RowContent, Title } from './HeaderElements';

const Header = (props: IHeader.IProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { backButtonState } = useAppSelector((state) => state.common);
  const { title, hasBack, children } = props;

  return (
    <Container hasChildren={!!children}>
      <RowContent>
        {hasBack ? (
          <BackButton
            onClick={() =>
              backButtonState === 'allow'
                ? navigate(-1)
                : dispatch(toggleBackButtonState('showErrorModal'))
            }
            className={'icon-Big-Arrows'}
          />
        ) : (
          <EmptyBox />
        )}
        <Title>{title}</Title>
        <EmptyBox />
      </RowContent>
      <ChildContent>{children}</ChildContent>
    </Container>
  );
};

export { Header };
